import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { FundWithFieldValues } from "../../../../api/types/fundStructureTypes";
import { columnDefinitions } from "./fundsGridDataProvider";

interface Props {
  funds: FundWithFieldValues[];
  isLoading: boolean;
}

const FundsGrid = ({ funds, isLoading }: Props) => {
  return (
    <DataGrid<FundWithFieldValues>
      loading={isLoading}
      noRowsText="No funds"
      columns={columnDefinitions}
      rows={funds}
      disableColumnSorting
    />
  );
};

export default FundsGrid;
